/* tslint:disable */
/* eslint-disable */
/**
 * My Title
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ObservationResponse
 */
export interface ObservationResponse {
    /**
     * 
     * @type {number}
     * @memberof ObservationResponse
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ObservationResponse
     */
    externalId?: string;
    /**
     * 
     * @type {number}
     * @memberof ObservationResponse
     */
    categoryTypeId?: number;
    /**
     * 
     * @type {number}
     * @memberof ObservationResponse
     */
    dataLevelId?: number;
    /**
     * 
     * @type {number}
     * @memberof ObservationResponse
     */
    entityId?: number;
    /**
     * 
     * @type {number}
     * @memberof ObservationResponse
     */
    observableItemId?: number;
    /**
     * 
     * @type {string}
     * @memberof ObservationResponse
     */
    value?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ObservationResponse
     */
    unitId?: number;
    /**
     * 
     * @type {number}
     * @memberof ObservationResponse
     */
    actionTypeId?: number;
    /**
     * 
     * @type {string}
     * @memberof ObservationResponse
     */
    entityExternalId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ObservationResponse
     */
    fileReceived?: boolean;
}

/**
 * Check if a given object implements the ObservationResponse interface.
 */
export function instanceOfObservationResponse(value: object): value is ObservationResponse {
    return true;
}

export function ObservationResponseFromJSON(json: any): ObservationResponse {
    return ObservationResponseFromJSONTyped(json, false);
}

export function ObservationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ObservationResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'externalId': json['externalId'] == null ? undefined : json['externalId'],
        'categoryTypeId': json['categoryTypeId'] == null ? undefined : json['categoryTypeId'],
        'dataLevelId': json['dataLevelId'] == null ? undefined : json['dataLevelId'],
        'entityId': json['entityId'] == null ? undefined : json['entityId'],
        'observableItemId': json['observableItemId'] == null ? undefined : json['observableItemId'],
        'value': json['value'] == null ? undefined : json['value'],
        'unitId': json['unitId'] == null ? undefined : json['unitId'],
        'actionTypeId': json['actionTypeId'] == null ? undefined : json['actionTypeId'],
        'entityExternalId': json['entityExternalId'] == null ? undefined : json['entityExternalId'],
        'fileReceived': json['fileReceived'] == null ? undefined : json['fileReceived'],
    };
}

export function ObservationResponseToJSON(json: any): ObservationResponse {
    return ObservationResponseToJSONTyped(json, false);
}

export function ObservationResponseToJSONTyped(value?: ObservationResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'externalId': value['externalId'],
        'categoryTypeId': value['categoryTypeId'],
        'dataLevelId': value['dataLevelId'],
        'entityId': value['entityId'],
        'observableItemId': value['observableItemId'],
        'value': value['value'],
        'unitId': value['unitId'],
        'actionTypeId': value['actionTypeId'],
        'entityExternalId': value['entityExternalId'],
        'fileReceived': value['fileReceived'],
    };
}

